export const INITIALIZATION_GOOGLE_AUTH = 'kindbody/initialization/GOOGLE_AUTH';
